import * as Sentry from "@sentry/browser";
import instrumentSentry from "./sentry/instrument";

instrumentSentry(Sentry, "js");

export { Sentry };

